<template>
  <div ref="mapChart" :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts';
  import worldJson from 'echarts-map/json/world.json';

  export default {
    name: 'World',
    props: ['countriesData', 'height'],
    data() {
      return {
        data: [],
        myChart: {},
        style: '',
        mapCountriesNames: {
          BAHAMAS: 'The Bahamas',
          BAHRAIN: '-------',
          'BOSNIA AND HERZEGOVINA': 'Bosnia and Herzegovina',
          'BURKINA FASO': 'Burkina Faso',
          'COSTA RICA': 'Costa Rica',
          'CZECH REPUBLIC': 'Czech Republic',
          CZECHOSLAVAKIA: 'Czech Republic',
          "CÃ”TE D'IVOIRE": 'Ivory Coast',
          'DOMINICAN REPUBLIC': 'Dominican Republic',
          'EL SALVADOR': 'El Salvador',
          'FRENCH GUIANA': '-------',
          'FRENCH POLYNESIA': '-------',
          'HEARD ISLAND AND MCDONALD ISLANDS': '------',
          'HONG KONG': '-------',
          'IRAN, ISLAMIC REPUBLIC OF': 'Iran',
          "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF": 'North Korea',
          'KOREA, REPUBLIC OF': 'South Korea',
          'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF': 'Macedonia',
          MALTA: '-------',
          'MOLDOVA, REPUBLIC OF': 'Moldova',
          MONACO: '--------',
          'NEW ZEALAND': 'New Zealand',
          'PUERTO RICO': '---------',
          'RUSSIAN FEDERATION': 'Russia',
          'SAUDI ARABIA': 'Saudi Arabia',
          SERBIA: 'Republic of Serbia',
          'SERBIA AND MONTENEGRO': '--------',
          SINGAPORE: '--------',
          'SOUTH AFRICA': 'South Africa',
          'SRI LANKA': 'Sri Lanka',
          'SYRIAN ARAB REPUBLIC': 'Syria',
          TAIWAN: '------',
          'TANZANIA, UNITED REPUBLIC OF': 'United Republic of Tanzania',
          'TRINIDAD AND TOBAGO': 'Trinidad and Tobago',
          'UNITED ARAB EMIRATES': 'United Arab Emirates',
          'UNITED KINGDOM': 'United Kingdom',
          'UNITED STATES': 'United States of America',
          'VENEZUELA, BOLIVARIAN REPUBLIC OF': 'Venezuela',
          'VIET NAM': 'Vietnam',
          YUGOSLAVIA: '---------',
        },
      };
    },
    created() {
      this.style = `width:100%; max-height:100%; min-height:${this.height}`;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
      this.countriesData.forEach((element, index) => {
        let countryName = '';
        if (Object.keys(this.mapCountriesNames).includes(element['country'])) {
          countryName = this.mapCountriesNames[element['country']];
        } else {
          let country = element['country'].toLowerCase();
          countryName = country.charAt(0).toUpperCase() + country.slice(1);
        }
        this.data.push({
          name: countryName,
          value: 1,
          screened: element['enrollmentData']['screened'],
          screenFailed: element['enrollmentData']['screenFailed'],
          completed: element['enrollmentData']['completed'],
          randomized: element['enrollmentData']['randomized'],
        });
      });
    },
    methods: {},
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      echarts.registerMap('world', worldJson);
      this.myChart = echarts.init(this.$refs.mapChart);
      let option;
      option = {
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        },
        tooltip: {
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2,
          formatter: function(params) {
            if (params.data !== undefined) {
              return `<b>${params.name}</b></br>
                  Screened : ${params.data.screened} <br />
                  Screen Failed : ${params.data.screenFailed} <br />
                  Randomized : ${params.data.randomized} <br />
                  Completed : ${params.data.completed} <br /> `;
            } else {
              return `<b>${params.name}</b></br>`;
            }
          },
        },
        visualMap: {
          min: 0,
          max: 10,
          inRange: {
            color: ['#0095FF'],
          },
          show: false,
        },
        series: [
          {
            name: 'Enrollment',
            type: 'map',
            map: 'world',
            emphasis: {
              label: {
                show: true,
              },
            },
            data: this.data,
          },
        ],
      };
      this.myChart.setOption(option);
    },
  };
</script>

<style></style>
